import { toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, renderList as _renderList, withKeys as _withKeys } from "vue"

const _hoisted_1 = {
  key: 0,
  class: "pagination-controls"
}
const _hoisted_2 = { class: "pagination-summary" }
const _hoisted_3 = { class: "results-copy" }
const _hoisted_4 = { class: "pagination-actions" }
const _hoisted_5 = ["disabled"]
const _hoisted_6 = ["disabled"]
const _hoisted_7 = { class: "pagination-summary" }
const _hoisted_8 = { class: "page-size-control" }
const _hoisted_9 = ["value", "disabled"]
const _hoisted_10 = ["value"]
const _hoisted_11 = { class: "results-copy" }
const _hoisted_12 = { class: "pagination-actions" }
const _hoisted_13 = ["disabled"]
const _hoisted_14 = { class: "pagination-copy" }
const _hoisted_15 = {
  key: 0,
  class: "jump-to-page"
}
const _hoisted_16 = ["max", "value", "disabled"]
const _hoisted_17 = ["disabled"]
const _hoisted_18 = ["disabled"]

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  return (_ctx.showControls)
    ? (_openBlock(), _createElementBlock("div", _hoisted_1, [
        (_ctx.isServerMode)
          ? (_openBlock(), _createElementBlock(_Fragment, { key: 0 }, [
              _createElementVNode("div", _hoisted_2, [
                _createElementVNode("span", _hoisted_3, " Exibindo " + _toDisplayString(_ctx.serverItemsLabel) + " de " + _toDisplayString(_ctx.limit) + " (pagina " + _toDisplayString(_ctx.serverCurrentPage) + ") ", 1)
              ]),
              _createElementVNode("div", _hoisted_4, [
                _createElementVNode("button", {
                  type: "button",
                  class: "btn btn-secondary",
                  disabled: _ctx.isPrevDisabled,
                  onClick: _cache[0] || (_cache[0] = ($event: any) => (_ctx.$emit('prev')))
                }, " Anterior ", 8, _hoisted_5),
                _createElementVNode("button", {
                  type: "button",
                  class: "btn btn-secondary",
                  disabled: _ctx.isNextDisabled,
                  onClick: _cache[1] || (_cache[1] = ($event: any) => (_ctx.$emit('next')))
                }, " Proxima ", 8, _hoisted_6)
              ])
            ], 64))
          : (_openBlock(), _createElementBlock(_Fragment, { key: 1 }, [
              _createElementVNode("div", _hoisted_7, [
                _createElementVNode("label", _hoisted_8, [
                  _cache[8] || (_cache[8] = _createElementVNode("span", null, "Itens por pagina", -1)),
                  _createElementVNode("select", {
                    value: _ctx.itemsPerPage,
                    disabled: _ctx.disabled,
                    onChange: _cache[2] || (_cache[2] = 
//@ts-ignore
(...args) => (_ctx.handleItemsPerPageChange && _ctx.handleItemsPerPageChange(...args)))
                  }, [
                    (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.pageSizeOptions, (option) => {
                      return (_openBlock(), _createElementBlock("option", {
                        key: option,
                        value: option
                      }, _toDisplayString(option), 9, _hoisted_10))
                    }), 128))
                  ], 40, _hoisted_9)
                ]),
                _createElementVNode("span", _hoisted_11, " Exibindo " + _toDisplayString(_ctx.firstItem) + "-" + _toDisplayString(_ctx.lastItem) + " de " + _toDisplayString(_ctx.totalItems), 1)
              ]),
              _createElementVNode("div", _hoisted_12, [
                _createElementVNode("button", {
                  type: "button",
                  class: "btn btn-secondary",
                  disabled: _ctx.disabled || _ctx.currentPage <= 1,
                  onClick: _cache[3] || (_cache[3] = ($event: any) => (_ctx.emitPageChange(_ctx.currentPage - 1)))
                }, " Anterior ", 8, _hoisted_13),
                _createElementVNode("span", _hoisted_14, "Pagina " + _toDisplayString(_ctx.currentPage) + " de " + _toDisplayString(_ctx.normalizedTotalPages), 1),
                (_ctx.showJumpToPage)
                  ? (_openBlock(), _createElementBlock("label", _hoisted_15, [
                      _cache[9] || (_cache[9] = _createElementVNode("span", null, "Ir para", -1)),
                      _createElementVNode("input", {
                        type: "number",
                        min: "1",
                        max: _ctx.normalizedTotalPages,
                        value: _ctx.jumpPage,
                        disabled: _ctx.disabled,
                        onInput: _cache[4] || (_cache[4] = 
//@ts-ignore
(...args) => (_ctx.handleJumpInput && _ctx.handleJumpInput(...args))),
                        onKeyup: _cache[5] || (_cache[5] = _withKeys(
//@ts-ignore
(...args) => (_ctx.goToJumpPage && _ctx.goToJumpPage(...args)), ["enter"]))
                      }, null, 40, _hoisted_16),
                      _createElementVNode("button", {
                        type: "button",
                        class: "btn btn-secondary",
                        disabled: _ctx.disabled,
                        onClick: _cache[6] || (_cache[6] = 
//@ts-ignore
(...args) => (_ctx.goToJumpPage && _ctx.goToJumpPage(...args)))
                      }, " Ir ", 8, _hoisted_17)
                    ]))
                  : _createCommentVNode("", true),
                _createElementVNode("button", {
                  type: "button",
                  class: "btn btn-secondary",
                  disabled: _ctx.disabled || _ctx.currentPage >= _ctx.normalizedTotalPages,
                  onClick: _cache[7] || (_cache[7] = ($event: any) => (_ctx.emitPageChange(_ctx.currentPage + 1)))
                }, " Proxima ", 8, _hoisted_18)
              ])
            ], 64))
      ]))
    : _createCommentVNode("", true)
}